import { Slide } from '@/components/core/Slide';
import videoFile from './13-eva.webm';
import audioFile from './14-eva-song.mp3';

export const slide = () => {
  return (
    <Slide
      notes="EVA video demonstration"
      audio={audioFile}
      visualizer="full"
      transition="fade"
      background={{
        video: videoFile,
      }}
    >
      <div className="relative z-10 flex items-center justify-center h-full">
        <h1 className="text-8xl font-light text-white tracking-wider">EVA</h1>
      </div>
    </Slide>
  );
};
